// extracted by mini-css-extract-plugin
export default {"signInForm":"signIn_signInForm__P38tx","label":"signIn_label__YovEx"};